const images = {
  appLogo: require("../assets/images/App-logo.png"),
};

export default images;
